import { render, staticRenderFns } from "./PaseoDelParque.vue?vue&type=template&id=263acf4c"
import script from "./PaseoDelParque.vue?vue&type=script&lang=js"
export * from "./PaseoDelParque.vue?vue&type=script&lang=js"
import style0 from "./PaseoDelParque.vue?vue&type=style&index=0&id=263acf4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports